<script setup>
defineProps({ incident: { type: Object, default: () => ({}) } });
</script>

<template>
  <v-layout-card>
    <v-row
      class="float-end ma-0"
      :dense="true"
      :no-gutters="true"
    >
      <v-col cols="auto">
        <slot name="commentButton" />
      </v-col>
      <v-col cols="auto">
        <slot name="assignButton" />
      </v-col>
    </v-row>
    <v-card-title>{{ $t(`incidents.${incident.type}.title`) }}</v-card-title>
    <v-card-text>
      <pre><code>{{ JSON.stringify(incident, null, 2) }}</code></pre>
    </v-card-text>
    <v-card-actions class="justify-end">
      <slot name="genericActions" />
    </v-card-actions>
  </v-layout-card>
</template>
